// @ts-nocheck
import { useNavigate } from 'react-router-dom';
import { Card, CardBody } from '@components/card/card.jsx';

function PagesError() {
  const navigate = useNavigate();

  function handleBackBtn() {
    navigate(-1, { replace: true });
  }

  return (
    <div className='error-page'>
      <div className='error-page-content'>
        <Card className='mb-5 mx-auto' style={{ maxWidth: '320px' }}>
          <CardBody>
            <Card>
              <div className='error-code'>404</div>
            </Card>
          </CardBody>
        </Card>
        <h1>Oops!</h1>
        <h3>We can't seem to find the page you're looking for</h3>
        <hr />

        <button onClick={handleBackBtn} className='btn btn-outline-theme px-3 rounded-pill'>
          <i className='fa fa-arrow-left me-1 ms-n1'></i> Go Back
        </button>
      </div>
    </div>
  );
}

  export default PagesError;

  
// import { useRouteError, useNavigate } from 'react-router-dom';
// import { Card, CardBody } from '@components/card/card.jsx';

// function PagesError() {
//   const error = useRouteError();
//   const navigate = useNavigate();

//   // تحديد نوع الخطأ
//   let statusCode = 500;
//   let title = 'حدث خطأ ما';
//   let message = 'نعتذر، حدث خطأ أثناء تحميل الصفحة.';

//   if (error && typeof error === 'object') {
//     // حالة: خطأ من loader أو component
//     if ('status' in error) {
//       statusCode = error.status;
//     }

//     if (error.statusText) {
//       message = error.statusText;
//     }

//     if (error.message) {
//       message = error.message;
//     }
//   }

//   // تخصيص الرسائل حسب الكود
//   switch (statusCode) {
//     case 404:
//       title = 'الصفحة غير موجودة';
//       message = 'نعتذر، لا يمكن العثور على الصفحة التي تبحث عنها.';
//       break;

//     case 403:
//       title = 'غير مصرح به';
//       message = 'ليس لديك صلاحيات للوصول إلى هذه الصفحة.';
//       break;

//     case 401:
//       title = 'غير مسجل الدخول';
//       message = 'يجب تسجيل الدخول للوصول إلى هذه الصفحة.';
//       break;

//     case 500:
//       title = 'خطأ داخلي في الخادم';
//       message = error?.message || 'حدث خطأ في الخادم. الرجاء المحاولة لاحقًا.';
//       break;

//     default:
//       if (message.includes('Failed to fetch')) {
//         statusCode = 'NET';
//         title = 'مشكلة في الاتصال';
//         message = 'تعذر الاتصال بالخادم. تحقق من اتصال الإنترنت.';
//       } else if (error instanceof Error) {
//         message = error.message;
//       }
//   }

//   const handleBackBtn = () => {
//     navigate(-1, { replace: true });
//   };

//   const handleGoHome = () => {
//     navigate('/', { replace: true });
//   };

//   return (
//     <div className='error-page d-flex align-items-center justify-content-center'>
//       <div className='error-page-content text-center'>
//         <Card className='mb-4 mx-auto shadow-sm' style={{ maxWidth: '360px' }}>
//           <CardBody>
//             <div
//               className='error-code rounded-circle mx-auto d-flex align-items-center justify-content-center'
//               style={{
//                 width: '80px',
//                 height: '80px',
//                 background: '#f8d7da',
//                 color: '#dc3545',
//                 fontSize: '2rem',
//                 fontWeight: 'bold'
//               }}
//             >
//               {statusCode === 'NET' ? '⚠' : statusCode}
//             </div>
//           </CardBody>
//         </Card>

//         <h1>{title}</h1>
//         <p className='text-muted mb-4'>{message}</p>

//         <div className='error-actions d-flex gap-3 justify-content-center'>
//           <button onClick={handleBackBtn} className='btn btn-outline-secondary px-3 rounded-pill'>
//             <i className='fa fa-arrow-left me-1'></i> رجوع
//           </button>
//           <button onClick={handleGoHome} className='btn btn-primary px-3 rounded-pill'>
//             <i className='fa fa-home me-1'></i> الصفحة الرئيسية
//           </button>
//         </div>

//         {/* عرض التفاصيل فقط في بيئة التطوير */}
//         {process.env.NODE_ENV === 'development' && (
//           <div className='error-details mt-4 p-3 text-start bg-light rounded'>
//             <small>
//               <strong>Error:</strong> {error instanceof Error ? error.stack : JSON.stringify(error)}
//             </small>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }

// export default PagesError;
